import React from 'react';

import StatusPage from '../../components/StatusPage';
import messages from './messages';

const UnsubscribeError = ({ children }: { children: React.ReactNode }) => (
  <StatusPage
    variant="error"
    pageName="unsubscribe-error"
    messages={messages}
    actions={[
      { to: '/contact', label: messages.contactSupport, variant: 'primary' },
      { to: '/', label: messages.returnHome, variant: 'secondary' },
    ]}
  >
    {children}
  </StatusPage>
);

export default UnsubscribeError;
